import { render, staticRenderFns } from "./ChooseContact.vue?vue&type=template&id=c4553986&scoped=true&"
import script from "./ChooseContact.vue?vue&type=script&lang=js&"
export * from "./ChooseContact.vue?vue&type=script&lang=js&"
import style0 from "./ChooseContact.vue?vue&type=style&index=0&id=c4553986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4553986",
  null
  
)

export default component.exports